import type { Template } from "@/types";

export const SQ_07_H0_V7: Template[] = [
    {
        id: "sq-07-h0v7-01",
        name: "SQ 01 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 206, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 618, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "5", x: 824, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1030, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1236, y: 209, width: 198, height: 299, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-02",
        name: "SQ 02 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 74, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 265, y: 74, width: 188, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 461, y: 74, width: 188, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 68, y: 363, width: 189, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 265, y: 363, width: 188, height: 280, rotation: 0, imageRotation: 0 },
            { id: "6", x: 461, y: 363, width: 188, height: 280, rotation: 0, imageRotation: 0 },
            { id: "7", x: 863, y: 74, width: 385, height: 569, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-03",
        name: "SQ 03 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 217, y: 50, width: 138, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 50, width: 137, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 258, width: 138, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 258, width: 137, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 217, y: 466, width: 138, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 363, y: 466, width: 137, height: 200, rotation: 0, imageRotation: 0 },
            { id: "7", x: 875, y: 50, width: 401, height: 616, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-04",
        name: "SQ 04 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 116, y: 0, width: 485, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 785, y: 73, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 982, y: 73, width: 188, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1178, y: 73, width: 188, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 785, y: 362, width: 189, height: 281, rotation: 0, imageRotation: 0 },
            { id: "6", x: 982, y: 362, width: 188, height: 281, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1178, y: 362, width: 188, height: 281, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-05",
        name: "SQ 05 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 46, y: 50, width: 413, height: 617, rotation: 0, imageRotation: 0 },
            { id: "2", x: 467, y: 50, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 467, y: 362, width: 204, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 868, y: 50, width: 204, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 868, y: 363, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 50, width: 203, height: 305, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 363, width: 203, height: 304, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-06",
        name: "SQ 06 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 74, width: 441, height: 569, rotation: 0, imageRotation: 0 },
            { id: "2", x: 789, y: 74, width: 379, height: 569, rotation: 0, imageRotation: 0 },      
            { id: "3", x: 521, y: 74, width: 124, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 521, y: 267, width: 124, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 521, y: 459, width: 124, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1176, y: 74, width: 186, height: 281, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1176, y: 363, width: 186, height: 280, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-07-h0v7-07",
        name: "SQ 07 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 143, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 143, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "3", x: 786, y: 143, width: 136, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 786, y: 363, width: 136, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 930, y: 143, width: 292, height: 431, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1229, y: 143, width: 136, height: 212, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1229, y: 363, width: 136, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-08",
        name: "SQ 08 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 143, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 143, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "3", x: 786, y: 143, width: 286, height: 431, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1080, y: 143, width: 139, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 363, width: 139, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1227, y: 143, width: 138, height: 212, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1227, y: 363, width: 138, height: 211, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-09",
        name: "SQ 09 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 144, y: 143, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 437, y: 143, width: 136, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 437, y: 363, width: 136, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 867, y: 51, width: 205, height: 304, rotation: 0, imageRotation: 0 },
            { id: "5", x: 867, y: 363, width: 205, height: 303, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 51, width: 204, height: 304, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 363, width: 204, height: 303, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h0v7-10",
        name: "SQ 10 - H0V7",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h0_v7_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 75, width: 345, height: 567, rotation: 0, imageRotation: 0 },
            { id: "2", x: 353, y: 75, width: 345, height: 567, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 75, width: 344, height: 567, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1058, y: 75, width: 184, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1058, y: 363, width: 184, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1250, y: 75, width: 184, height: 280, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1250, y: 363, width: 184, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

];
